import React from 'react';
import { BookOpen, PenTool, Star, Sparkles, Award, TrendingUp } from 'lucide-react';

const iconMap = {
  book: BookOpen,
  pen: PenTool,
  star: Star,
  sparkles: Sparkles,
  award: Award,
  trending: TrendingUp
};

const AnimatedIcon = ({ icon = 'book', position = 'top-left', size = 80, delay = 0, opacity = 0.08 }) => {
  const Icon = iconMap[icon] || BookOpen;
  
  const positionClasses = {
    'top-left': 'top-10 left-10',
    'top-right': 'top-10 right-10',
    'bottom-left': 'bottom-10 left-10',
    'bottom-right': 'bottom-10 right-10',
    'top-center': 'top-10 left-1/2 -translate-x-1/2',
    'bottom-center': 'bottom-10 left-1/2 -translate-x-1/2',
    'middle-left': 'top-1/2 left-10 -translate-y-1/2',
    'middle-right': 'top-1/2 right-10 -translate-y-1/2'
  };

  return (
    <div 
      className={`absolute ${positionClasses[position]} pointer-events-none z-0`}
      style={{
        animation: `floatIcon 6s ease-in-out infinite`,
        animationDelay: `${delay}s`,
        opacity: opacity
      }}
    >
      <Icon 
        size={size} 
        className="text-[#F4D03F]"
        strokeWidth={1.5}
      />
    </div>
  );
};

export default AnimatedIcon;
